module Meevo.Plugins.PackageLookup {
  class PackageLookupController extends Meevo.Components.CommonClasses.CommonControllerBase {

    protected packageNumber: string;

        static $inject = [
          "meevo.AppSettings",
          "meevo.components.common.BusinessInfoDataService",
          "meevo.components.modal.ModalService",
          "meevo.components.common.IdentityService",
          "meevo.components.logging.LoggingService",
          "meevo.components.tracking.TrackingService",
          "meevo.components.common.SecurityService",
          "$rootScope",
          "$scope",
          "$state",
          "meevo.ContextParams",
          'meevo.components.short-cuts.ShortCutsService',

          "meevo.components.busy.BusyService",
          "$translate"];

        constructor(protected appSettings: Meevo.Components.Common.IAppSettings,
          protected dataService: Meevo.Components.CommonClasses.ICommonDataService,
          protected modalService: Meevo.Components.Modal.IModalService,
          protected identityService: Meevo.Components.Common.IIdentityService,
          protected loggingService: Meevo.Components.Logging.ILoggingService,
          protected trackingService: Meevo.Components.Tracking.ITrackingService,
          protected securityService: Meevo.Components.Common.ISecurityService,
          protected $rootScope: angular.IRootScopeService,
          protected $scope: angular.IScope,
          protected $state: any,
          protected contextParams: Meevo.IContextParams,
          protected shortCutsService: Meevo.Components.ShortCuts.IShortCutsService,

          protected busyService: Meevo.Components.Busy.IBusyService,
          protected $translate: angular.translate.ITranslateService) {

          super(appSettings, dataService, modalService, identityService, loggingService, $scope, contextParams, $state, $rootScope, shortCutsService);

          this.createContext();
        }

        createContext(): void {
          let vm = this;
          vm.busyService.start();
          vm.securityService.checkSecurityKey(vm.meevoSecurityKeys.DATA_PACKAGELOOKUP + Meevo.Components.Common.SecurityParts.KEY_PART_READ).then(() => {
            let item = new Meevo.Model.TrackingItem(Model.NounEnum.PackageLookup, Model.VerbEnum.Viewed, null, null);
            vm.trackingService.saveTrackingInfo(item);
            vm.loggingService.trace("Opening package lookup.");
            vm.busyService.stop();
            vm.context = new PackageLookupContext(vm.appSettings, vm.dataService, vm.modalService, vm.identityService, vm.loggingService, vm.securityService);
            super.createContext();

            let gc = "";
            if (vm.contextParams.params && vm.contextParams.params.packageNumber) {
              vm.packageNumber = vm.contextParams.params.packageNumber;
            }

            vm.context.postUpdate = (model: any) => {
              if (Model.Guard.isSomething(this.context.closeCallback))
                this.context.closeCallback(model, true);
            }

            let modalOptions: Meevo.Components.Modal.IModalOptions = {
              templateUrl: "app/plugins/packageLookup/packageLookupModal.template.html",
              controller: "meevo.plugins.packageLookup.PackageLookupModalController",
              controllerAs: "vm",
              bindToController: true,
              locals: {
                packageNumber: this.packageNumber
              }
            };

            this.modalService.showCustom(modalOptions)
              .finally(() => {
                this.closeContext();
              });

          });
        }

        closeContext = (): void => {
          this.$rootScope.$broadcast(Meevo.Components.Common.Messages.CLOSE_CONTEXT, this.$state.current, null);
        }
  }

  angular.module("meevo.plugins.packageLookup")
    .controller("meevo.plugins.packageLookup.PackageLookupController", PackageLookupController);
}